import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import {
  assertWarnungen,
  countPfostenarten,
  getInspiredArrangement,
  globalePfostenart,
  resetArrangement,
  warnungenMitPfostenIndex,
} from "./utils";

export default {
  name: "TestPfosten",
};

// Pfosten an Zaunelement mit Standardhöhe
export const testKlemmpfostenZaunelementEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.93, pfosten.echteLänge);
  assert.equals("2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert", pfosten.meta.Key);
};

export const testKlemmpfostenZaunelementAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.93, pfosten.echteLänge);
  assert.equals("2341 SYSTEM Klemmpfosten Anthrazit 192 cm | aufgeschraubt", pfosten.meta.Key);
};

export const testSteckpfostenZaunelementEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(2.33, pfosten.echteLänge);
  assert.equals("2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm", pfosten.meta.Key);
};

export const testSteckpfostenZaunelementAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.93, pfosten.echteLänge);
  assert.equals("2144 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 192 cm", pfosten.meta.Key);
};

// Pfosten an Zaunelement mit 0,95m Höhe
export const testKlemmpfostenZaunelement95cmEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  s.getElemente()[0].setKonfigurierbareHöhe(0.95);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.05, pfosten.echteLänge);
  assert.equals("2340 SYSTEM Klemmpfosten Anthrazit 105 cm | einbetoniert", pfosten.meta.Key);
};

export const testKlemmpfostenZaunelement95cmAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  s.getElemente()[0].setKonfigurierbareHöhe(0.95);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.05, pfosten.echteLänge);
  assert.equals("2340 SYSTEM Klemmpfosten Anthrazit 105 cm | aufgeschraubt", pfosten.meta.Key);
};

export const testSteckpfostenZaunelement95cmEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  s.getElemente()[0].setKonfigurierbareHöhe(0.95);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.52, pfosten.echteLänge);
  assert.equals("2359 SYSTEM Steckpfosten Anthrazit  Erdverbau 150 cm", pfosten.meta.Key);
};

export const testSteckpfostenZaunelement95cmAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  s.getElemente()[0].setKonfigurierbareHöhe(0.95);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isPfosten);
  assert.equals(1.05, pfosten.echteLänge);
  assert.equals("2358 SYSTEM Steckpfosten Anthrazit z.  Aufschrauben 105 cm", pfosten.meta.Key);
};

// Torpfostenset an Einzeltor für Standardhöhe, Standardhöhe -1, Vorgartentor (95cm), Vorgartentor +1, Vorgartentor -1
export const testTorpfostenEinzeltorEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(2.54, pfosten.echteLänge);
  assert.equals("E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltorAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(1.94, pfosten.echteLänge);
  assert.equals("E1244 Torpfosten aufschrauben 180 anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltor179cmEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  s.getElemente()[0].setKonfigurierbareHöhe(1.79);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(2.54, pfosten.echteLänge);
  assert.equals("E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltor179cmAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  s.getElemente()[0].setKonfigurierbareHöhe(1.79);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  console.log(pfosten);
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(1.94, pfosten.echteLänge);
  assert.equals("E1244 Torpfosten aufschrauben 180 anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltor96cmEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  s.getElemente()[0].setKonfigurierbareHöhe(0.96);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(1.7000000000000002, pfosten.echteLänge);
  assert.equals("Torpfosten einbetonieren hhh anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltor96cmAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  s.getElemente()[0].setKonfigurierbareHöhe(0.96);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(1.1, pfosten.echteLänge);
  assert.equals("Torpfosten aufschrauben hhh anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltor95cmEinbetoniert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  s.getElemente()[0].setKonfigurierbareHöhe(0.95);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(1.69, pfosten.echteLänge);
  assert.equals("Torpfosten einbetonieren hhh anthrazit Schlossseite", pfosten.meta.Key);
};

export const testTorpfostenEinzeltor95cmAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  s.getElemente()[0].setKonfigurierbareHöhe(0.95);
  agt.update3d();
  const pfosten = s.getPartsAndPfosten()[0];
  pfosten.bodenbefestigungAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  agt.update3d();
  assert.isTrue(pfosten.isTorpfosten);
  assert.equals(1.09, pfosten.echteLänge);
  assert.equals("Torpfosten aufschrauben hhh anthrazit Schlossseite", pfosten.meta.Key);
};

export const testWarnungBeiImplizitenPfostenartWechsel: Test = async () => {
  const agt = getInspiredArrangement("Inspiration Gada");
  agt.grundriss.setStandardForm("Strecke", [6]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.getElemente()[1].setJsonPartial({
    breite: 1.2,
    höhe: 1.79,
    füllungAuswahlwert: "SYSTEM GLAS Texta",
  });
  agt.update3d();
  const s = agt.segmente[0];
  assert.deepEquals(
    [
      null,
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "1084 GADA Rechteck mit Gitter 179 x 179 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "2474 SYSTEM GLAS Alpha/Beta/Matt/Texta auf Mass",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "1084 GADA Rechteck mit Gitter 179 x 179 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
    ],
    s.getPartsAndPfosten().map((p) => p.meta?.Key)
  );
  agt.changePfosten({ pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Holzpfosten") });
  assert.deepEquals(
    [
      null,
      "1597 SELECT Pfosten mit Dom 9 x 9 x 195 cm_einbetoniert | Eckpfosten",
      "1084 GADA Rechteck mit Gitter 179 x 179 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "2474 SYSTEM GLAS Alpha/Beta/Matt/Texta auf Mass",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "1084 GADA Rechteck mit Gitter 179 x 179 cm",
      "1597 SELECT Pfosten mit Dom 9 x 9 x 195 cm_einbetoniert | Eckpfosten",
    ],
    s.getPartsAndPfosten().map((p) => p.meta?.Key)
  );
  const message = APP.logMessagesForTests.find(
    (m) => m.text == "Die Pfostenart der markierten Pfosten ist unveränderlich!"
  );
  assert.isNotNull(message, "Die Pfostenart-Message ist vorhanden");
  const warnungenUnique = () => _.uniq(agt.warnungen.map((w) => w.text));
  assert.deepEquals(["Metallpfosten"], warnungenUnique());
  agt.update3d();
  assert.deepEquals(
    ["Metallpfosten"],
    warnungenUnique(),
    "auch nach einem weiteren Update bleiben die Warnungen erhalten"
  );
  message.onClose();
  agt.update3d();
  assert.deepEquals([], APP.logMessagesForTests);
  assert.deepEquals(
    [],
    agt.warnungen,
    "erst mit dem Schließen der Nachricht verschwindet die Warnung"
  );
};

export const testGadaHolztorBrauchtMetallpfostenAnGlaselement: Test = async () => {
  const agt = getInspiredArrangement("Inspiration Gada");
  agt.grundriss.setStandardForm("Strecke", [6]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.changePfosten({ pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Holzpfosten") });
  agt.getElemente()[0].setJsonPartial({
    breite: 0.98,
    höhe: 1.79,
    füllungAuswahlwert: "Gada Natur kdi",
    form: "Einzeltor",
    massAuswahlwert: "Holz_Tor_Gada_98x179",
  });
  agt.getElemente()[1].setJsonPartial({
    breite: 1.2,
    höhe: 1.79,
    füllungAuswahlwert: "SYSTEM GLAS Texta",
  });
  agt.update3d();
  const s = agt.segmente[0];
  assert.equals("Holzpfosten", globalePfostenart());
  assert.deepEquals(
    [
      null,
      "E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite",
      "1089 GADA Tor gerade für Schloss 98 x 179 cm",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "2474 SYSTEM GLAS Alpha/Beta/Matt/Texta auf Mass",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "1084 GADA Rechteck mit Gitter 179 x 179 cm",
      "1597 SELECT Pfosten mit Dom 9 x 9 x 195 cm_einbetoniert | Eckpfosten",
    ],
    s.getPartsAndPfosten().map((p) => p.meta?.Key)
  );
  const message = APP.logMessagesForTests.find(
    (m) => m.text == "Die Pfostenart der markierten Pfosten ist unveränderlich!"
  );
  assert.isNotNull(message, "Die Pfostenart-Message ist vorhanden");
  assert.deepEquals(
    [
      ["Metalltorpfosten", 1, 2],
      ["Metallpfosten", 3],
    ],
    warnungenMitPfostenIndex()
  );

  agt.changePfosten({ pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Metallpfosten") });
  assert.equals("Metallpfosten", globalePfostenart());
  assert.deepEquals(
    [
      null,
      "E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite",
      "1089 GADA Tor gerade für Schloss 98 x 179 cm",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "2474 SYSTEM GLAS Alpha/Beta/Matt/Texta auf Mass",
      "2777 SYSTEM U-Klemmprofil Anthrazit 192 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "1084 GADA Rechteck mit Gitter 179 x 179 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
    ],
    s.getPartsAndPfosten().map((p) => p.meta?.Key)
  );
  agt.update3d();
  assert.deepEquals(
    [["Metalltorpfosten", 1, 2]],
    warnungenMitPfostenIndex(),
    "auch nach einem weiteren Update bleiben die Warnungen erhalten"
  );
  message.onClose();
  agt.update3d();
  assert.deepEquals(
    ["Durch Ihre Aktion wurde die Pfostenart eines oder mehrerer Pfosten geändert."],
    APP.logMessagesForTests.map((m) => m.text)
  );
  assert.deepEquals(
    [],
    agt.warnungen,
    "erst mit dem Schließen der Nachricht verschwindet die Warnung"
  );
};

export const testEAntriebInfo: Test = async () => {
  // Metalltorpfosten-Anzahl stimmt nicht überein (Metadaten-Änderung)
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.getElemente()[3].setJsonPartial({
    type: "Element",
    breite: 3.41,
    höhe: 1.8,
    füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
    eAntriebAuswahlwert: "E_Antrieb_mit",
    form: "Doppeltor",
    massAuswahlwert: "Doppeltor_Easy",
    detailSerie: "SYSTEM WPC PLATINUM XL",
  });
  agt.update3d();
  return;
  const s = agt.segmente[0];
  agt.changePfosten({ pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten") });
  agt.changePfosten({ pfostenfarbeAuswahlwert: APP.richMetadata.findAuswahlwert("Weiß") });
  agt.changePfosten({ pfostenfarbeAuswahlwert: APP.richMetadata.findAuswahlwert("Silber") });
  assert.equals("Steckpfosten", agt.auswahlAccessoren.Pfostenart.auswahlwert.Key);
  assert.equals("Silber", agt.auswahlAccessoren.Pfostenfarbe.auswahlwert.Key);
  assert.deepEquals([["Metalltorpfosten", 2, 3]], warnungenMitPfostenIndex());
  assert.deepEqualsPicked(
    [
      "Durch Ihre Aktion wurde die Pfostenart eines oder mehrerer Pfosten geändert.",
      "Die Pfostenart der markierten Pfosten ist unveränderlich!",
      "Neue oder größere Leerräume sind durch die geringere Pfostenbreite des Steckpfosten entstanden!",
      "⚠ Die Befestigung des E-Antriebs ist silber und weicht von der Pfostenfarbe ab",
    ],
    APP.logMessagesForTests.map((m) => m.text)
  );
};

export const testBodenbefestigungInfo: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.getElemente()[3].setJsonPartial({
    type: "Element",
    breite: 3.41,
    höhe: 1.8,
    füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
    eAntriebAuswahlwert: "E_Antrieb_mit",
    form: "Doppeltor",
    massAuswahlwert: "Doppeltor_Easy",
    detailSerie: "SYSTEM WPC PLATINUM XL",
  });
  agt.update3d();
  const s = agt.segmente[0];
  agt.changePfosten({
    bodenbefestigungAuswahlwert: APP.richMetadata.findAuswahlwert("Aufgeschraubt auf festem Boden"),
  });
  assert.equals(
    "Aufgeschraubt auf festem Boden",
    agt.auswahlAccessoren.Bodenbefestigung.auswahlwert.Key
  );
  assert.deepEquals([["Einbetoniert im Boden", 3, 4]], warnungenMitPfostenIndex());
  assert.deepEqualsPicked(
    [
      "Durch Ihre Aktion wurde die Pfostenart eines oder mehrerer Pfosten geändert.",
      "Die Bodenbefestigung der markierten Pfosten ist unveränderlich!",
    ],
    APP.logMessagesForTests.map((m) => m.text)
  );
};

export const testUmmantellungInfo: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.changePfosten({
    ummantelungAuswahlwert: APP.richMetadata.findAuswahlwert("Ummantelung_mit"),
  });
  assert.deepEquals([], warnungenMitPfostenIndex());
  assert.deepEqualsPicked(
    [],
    APP.logMessagesForTests.map((m) => m.text)
  );
  agt.changePfosten({ pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten") });
  agt.update3d();
  assert.deepEquals([["Ohne Ummantelung", 0, 1, 2, 3]], warnungenMitPfostenIndex());
  assert.deepEqualsPicked(
    ["Für die markierten Pfosten ist keine Ummantelung verfügbar!"],
    APP.logMessagesForTests.map((m) => m.text)
  );
};

export const testKeinePfostenartInfoBeiNormalemWechselUndSelektiert: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.setSelectedObjects(agt.getPfosten().slice(3, 4));
  agt.changePfosten(
    {
      pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten"),
    },
    agt.selectedObjects
  );
  assert.deepEqualsPicked(
    ["Pfostenart der selektierten Parts wurde individualisiert."],
    APP.logMessagesForTests.map((m) => m.text)
  );
  APP.logMessagesForTests = [];
  agt.changePfosten(
    {
      pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Klemmpfosten"),
    },
    agt.selectedObjects
  );
  assert.deepEqualsPicked(
    [],
    APP.logMessagesForTests.map((m) => m.text)
  );
};

export const testWechselDerPfostenartBetrifftAuchEckpfosten: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [6]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.changePfosten({
    pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten"),
  });
  assert.deepEquals(
    [
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
    ],
    agt.getPfosten().map((e) => e.meta.Key)
  );
  agt.update3d();
  assert.deepEquals(
    [
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
    ],
    agt.getPfosten().map((e) => e.meta.Key)
  );
  agt.changePfosten({
    pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Klemmpfosten"),
  });
  assert.deepEquals(
    [
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    agt.getPfosten().map((e) => e.meta.Key)
  );
  agt.update3d();
  assert.deepEquals(
    [
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    agt.getPfosten().map((e) => e.meta.Key)
  );
};

export const testKeinePfostenartInfoBeiNormalemWechselAufgeschraubt: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.changePfosten({
    bodenbefestigungAuswahlwert: APP.richMetadata.findAuswahlwert("Einbetoniert im Boden"),
  });
  assert.deepEqualsPicked(
    [],
    APP.logMessagesForTests.map((m) => m.text)
  );
  agt.changePfosten({
    bodenbefestigungAuswahlwert: APP.richMetadata.findAuswahlwert("Aufgeschraubt auf festem Boden"),
  });
  assert.deepEqualsPicked(
    [],
    APP.logMessagesForTests.map((m) => m.text)
  );
};

export const testPfostenartSpringtZurückUndRespektiertMehrheit1: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [10]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  _.last(agt.getElemente()).setJsonPartial({
    breite: 1.2,
    höhe: 1.8,
    füllungAuswahlwert: "SYSTEM GLAS Matt",
  });
  agt.update3d();
  assert.deepEquals(
    {
      Klemmpfosten: 7,
    },
    countPfostenarten()
  );
  assert.deepEquals("Klemmpfosten", globalePfostenart());
  agt.changePfosten({
    pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten"),
  });
  assert.deepEquals(
    {
      Klemmpfosten: 2,
      Steckpfosten: 5,
    },
    countPfostenarten()
  );
  assert.deepEquals("Steckpfosten", globalePfostenart());
  assert.deepEquals(
    [
      ["Klemmpfosten", 0, 6],
      ["Zusätzlicher Leerraum nach Wechsel auf Steckpfosten!", -1],
    ],
    warnungenMitPfostenIndex()
  );
  assert.deepEquals(
    [
      "Die Pfostenart der markierten Pfosten ist unveränderlich!",
      "Neue oder größere Leerräume sind durch die geringere Pfostenbreite des Steckpfosten entstanden!",
    ],
    APP.logMessagesForTests.map((l) => l.text)
  );
  APP.logMessagesForTests.forEach((l) => l.onClose && l.onClose());
  agt.update3d();
  assert.deepEquals(
    {
      Klemmpfosten: 2,
      Steckpfosten: 5,
    },
    countPfostenarten()
  );
  assert.deepEquals("Steckpfosten", globalePfostenart());
};

export const testPfostenartSpringtZurückUndRespektiertMehrheit2: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau");
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  _.last(agt.getElemente()).setJsonPartial({
    breite: 1.2,
    höhe: 1.8,
    füllungAuswahlwert: "SYSTEM GLAS Matt",
  });
  agt.update3d();
  assert.deepEquals(
    {
      Klemmpfosten: 3,
    },
    countPfostenarten()
  );
  assert.deepEquals("Klemmpfosten", globalePfostenart());
  agt.changePfosten({
    pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten"),
  });
  assert.deepEquals(
    {
      Klemmpfosten: 2,
      Steckpfosten: 1,
    },
    countPfostenarten()
  );
  assert.deepEquals("Steckpfosten", globalePfostenart());
  assert.deepEquals(
    [
      ["Klemmpfosten", 0, 2],
      ["Zusätzlicher Leerraum nach Wechsel auf Steckpfosten!", -1],
    ],
    warnungenMitPfostenIndex()
  );
  assert.deepEquals(
    [
      "Die Pfostenart der markierten Pfosten ist unveränderlich!",
      "Neue oder größere Leerräume sind durch die geringere Pfostenbreite des Steckpfosten entstanden!",
    ],
    APP.logMessagesForTests.map((l) => l.text)
  );
  APP.logMessagesForTests.forEach((l) => l.onClose && l.onClose());
  agt.update3d();
  assert.deepEquals(
    {
      Klemmpfosten: 2,
      Steckpfosten: 1,
    },
    countPfostenarten()
  );
  assert.deepEquals("Klemmpfosten", globalePfostenart());
};

export const testTorpfostenMitTorenBreiter120VerweigernAufgeschraubt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    massAuswahlwert: "Einzeltor_Easy",
    breite: 1.8,
  });
  s.addPart(element);
  agt.update3d();
  assert.equals(1.8, element.breite);
  agt.changePfosten({
    bodenbefestigungAuswahlwert: APP.richMetadata.findAuswahlwert("Aufgeschraubt auf festem Boden"),
  });
  assert.equals(1.8, element.breite);
  assertWarnungen(agt, ["Einbetoniert im Boden", "Einbetoniert im Boden"]);
  assert.deepEquals(
    ["Die Bodenbefestigung der markierten Pfosten ist unveränderlich!"],
    APP.logMessagesForTests.map((l) => l.text)
  );
};

export const testTauschenElementMitTorSetztFalschePfostenartZurück1: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.fillIndividuellSegmentsWithElements();
  agt.auswahlAccessoren.Füllung.setter(
    APP.richMetadata.findAuswahlwert("SYSTEM ALU Plus Bambus 15 cm")
  );
  const elementLinks = agt.getElemente()[1];
  const elementRechts = agt.getElemente()[2];

  agt.auswahlAccessoren.Pfostenart.setter(APP.richMetadata.findAuswahlwert("Klemmpfosten"));

  agt.update3d();
  agt.segmente[0].logit();
  console.log(
    "1 pfosten: " + agt.getPfosten()[2].id,
    agt.getPfosten()[2].toJSON().pfostenartAuswahlwert
  );
  // pfostenartAuswahlwert: "Klemmpfosten"
  // pfostenartAuswahlwertIndividualisiert: false

  elementLinks.change({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });

  agt.update3d();
  console.log(
    "2 pfosten: " + agt.getPfosten()[2].id,
    agt.getPfosten()[2].toJSON().pfostenartAuswahlwert
  );
  // pfostenartAuswahlwert: "Klemmpfosten"
  // pfostenartAuswahlwertIndividualisiert: false

  agt.tauscheBenachbarteElemente([elementLinks, elementRechts]);

  console.log(
    "3 pfosten: " + agt.getPfosten()[2].id,
    agt.getPfosten()[2].toJSON().pfostenartAuswahlwert
  );

  assert.deepEquals(
    [
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );
};

export const testTauschenElementMitTorSetztFalschePfostenartZurück2: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.fillIndividuellSegmentsWithElements();
  agt.auswahlAccessoren.Füllung.setter(
    APP.richMetadata.findAuswahlwert("SYSTEM ALU Plus Bambus 15 cm")
  );
  const elementLinks = agt.getElemente()[1];
  const elementRechts = agt.getElemente()[2];
  elementLinks.change({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  agt.auswahlAccessoren.Pfostenart.setter(APP.richMetadata.findAuswahlwert("Klemmpfosten"));

  agt.update3d();
  agt.segmente[0].logit();
  console.log(
    "1 pfosten: " + agt.getPfosten()[2].id,
    agt.getPfosten()[2].toJSON().pfostenartAuswahlwert
  );
  // pfostenartAuswahlwert: "Klemmpfosten"
  // pfostenartAuswahlwertIndividualisiert: false

  agt.tauscheBenachbarteElemente([elementLinks, elementRechts]);
  console.log(
    "3 pfosten: " + agt.getPfosten()[2].id,
    agt.getPfosten()[2].toJSON().pfostenartAuswahlwert
  );
  assert.deepEquals(
    [
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );
};

export const testTorpfostenfarbeAnthrazitNachWechselCaraAufAros: Test = async () => {
  const agt = getInspiredArrangement("Inspiration Longlife Cara");
  agt.grundriss.setStandardForm("Strecke", [6]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.getElemente()[1].setJsonPartial({
    breite: 0.98,
    höhe: 0.8,
    füllungAuswahlwert: "LONGLIFE CARA Weiss",
    form: "Einzeltor",
    massAuswahlwert: "Longlife_Vorgarten_Einzeltor_rund",
  });
  agt.update3d();
  const s = agt.segmente[0];
  assert.equals("Kunststoff Pfosten Longlife", globalePfostenart());
  assert.deepEquals(
    [
      undefined,
      "0742 LONGLIFE Pfosten Weiß 150 cm",
      "1101 LONGLIFE CARA Weiß rund 180 x 70 (80) cm",
      "Torpfosten einbetonieren 70 weiß Schlossseite",
      "1113 LONGLIFE CARA Weiß Tor rund DIN Links 98 x 70 (80) cm",
      "Torpfosten einbetonieren 70 weiß Aufhängeseite",
      "1101 LONGLIFE CARA Weiß rund 180 x 70 (80) cm",
      "0742 LONGLIFE Pfosten Weiß 150 cm",
    ],
    s.getPartsAndPfosten().map((p) => p.meta?.Key)
  );
  const inspiration = APP.richMetadata.findAuswahlwert("Inspiration AROS Vorgarten Anthrazit")
    ?.Inspiration[0];
  agt.inspiration = inspiration;
  agt.update3d();
  APP.arrangement.changeSelectedZaunElemente({
    füllungAuswahlwert: inspiration.Füllung,
  });
  agt.update3d();
  assert.equals("Metallpfosten", globalePfostenart());
  assert.deepEquals(
    [
      "1586 Metallpfosten Anthrazit Erdverbau 7 x 7 x 150 cm",
      "3864 AROS Vorgartenzaun Anthrazit 238 x 95 cm",
      "Torpfosten einbetonieren 90-95 anthrazit Schlossseite",
      "4963 AROS Mass Einzeltor",
      "Torpfosten einbetonieren 90-95 anthrazit Aufhängeseite",
      "3864 AROS Vorgartenzaun Anthrazit 238 x 95 cm",
      "1586 Metallpfosten Anthrazit Erdverbau 7 x 7 x 150 cm",
    ],
    s.getPartsAndPfosten().map((p) => p.meta?.Key)
  );
};
